<template>
  <div>
    <el-dialog
      title="配置查询"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="子设备列表" name="sub-devices-list">
          <el-table v-loading="loading" :data="tableDataForSubDeviceList" style="width: 100%">
            <el-table-column label="子设备ID" prop="deviceId"></el-table-column>
            <el-table-column label="子设备名称" prop="deviceName"></el-table-column>
            <el-table-column label="设备类型" prop="categoryName"></el-table-column>
            <el-table-column label="绑定时间" prop="createTime"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="场景列表" name="scene-list">
          <el-table v-loading="loading" :data="tableDataForScene" style="width: 100%">
            <el-table-column label="场景ID" prop="id"></el-table-column>
            <el-table-column label="场景名称" prop="name"></el-table-column>
            <el-table-column label="场景类型" prop="sceneType"></el-table-column>
            <el-table-column label="触发条件" prop="andStatus"></el-table-column>
            <el-table-column label="执行动作" prop="actions"></el-table-column>
            <el-table-column label="启用状态" prop="state"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="operate-container">
        <el-button type="primary" size="14" :loading="exportLoading" @click="handleExportExcel">
          {{ activeName === 'sub-devices-list' ? '导出子设备列表' : '导出场景列表' }}
        </el-button>
        <el-button size="14" @click="handlePublish">配置下发</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSubDeviceList, getSceneList, exportSubDeviceList, exportSceneList } from '@/api/device/log'

export default {
  name: 'configurationQueryDialog',
  data() {
    return {
      dialogVisible: false,
      activeName: 'sub-devices-list',
      gatewayDeviceId: '', // 缓存网关设备ID，供导出和配置下发使用
      tableDataForSubDeviceList: [],
      tableDataForScene: [],
      loading: false,
      exportLoading: false // 导出按钮的 loading 状态
    }
  },
  methods: {
    // 初始化对话框，参数为对象 { gatewayDeviceId }
    async init(params) {
      this.gatewayDeviceId = params?.gatewayDeviceId || ''
      this.dialogVisible = true
      this.activeName = 'sub-devices-list'
      await this.querySubDeviceList()
    },

    // Tab 切换事件
    async handleClick(tab) {
      if (tab.name === 'sub-devices-list') {
        await this.querySubDeviceList()
        return
      }
      await this.querySceneList()
    },

    // 查询子设备列表
    async querySubDeviceList() {
      if (!this.gatewayDeviceId) return
      this.loading = true
      try {
        const res = await getSubDeviceList({ gatewayDeviceId: this.gatewayDeviceId })
        this.tableDataForSubDeviceList = res.data?.data || []
      } catch (e) {
        console.error('加载子设备列表失败：', e)
      } finally {
        this.loading = false
      }
    },

    // 查询场景列表
    async querySceneList() {
      if (!this.gatewayDeviceId) return
      this.loading = true
      try {
        const res = await getSceneList({ gatewayDeviceId: this.gatewayDeviceId })
        this.tableDataForScene = res.data?.data || []
      } catch (e) {
        console.error('加载场景列表失败：', e)
      } finally {
        this.loading = false
      }
    },

    // 导出 Excel：根据当前 Tab 调用对应的导出接口
    async handleExportExcel() {
      if (!this.gatewayDeviceId) return
      this.exportLoading = true
      try {
        const queryApi = this.activeName === 'sub-devices-list' ? exportSubDeviceList : exportSceneList
        const res = await queryApi({ gatewayDeviceId: this.gatewayDeviceId })
        this.exportBlobFile(res)
      } catch (e) {
        this.$message.error('导出失败，请重试')
        console.error('导出失败：', e)
      } finally {
        this.exportLoading = false
      }
    },

    // 配置下发：跳转到父组件处理，复用 index.vue 中的确认弹窗逻辑
    handlePublish() {
      if (!this.gatewayDeviceId) return
      this.$emit('publish', this.gatewayDeviceId)
    },

    // 关闭对话框并清理数据
    handleClose() {
      this.dialogVisible = false
      this.tableDataForSubDeviceList = []
      this.tableDataForScene = []
      this.activeName = 'sub-devices-list'
      this.gatewayDeviceId = ''
    }
  }
}
</script>
<style scoped lang="scss">
.operate-container {
  padding-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
